export default "__VITE_ASSET__DuluYNS3__"